import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "flag--sprite",
  "use": "flag--sprite-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol viewBox=\"0 0 20 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"flag--sprite\">\n<path d=\"M18 6H8V8H18V20H2V8H4V12H6V4H12V0H4V6H2C0.9 6 0 6.9 0 8V20C0 21.1 0.9 22 2 22H18C19.1 22 20 21.1 20 20V8C20 6.9 19.1 6 18 6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol